import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { Link } from 'react-router-dom';

import cn from 'classnames';
import styles from './Input.scss';

class Input extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      editing: false
    };
  }

  componentDidMount() {
    this.setState({ editing: false });
  }

  getInputRef = (ref) => {
    this.input = ref;
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value });
    this.props.onChange && this.props.onChange(e);
  }

  handleSubmit = (e) => {
    e && e.preventDefault();
    this.setState({ editing: false });
    this.props.onSubmit(this.state.value);
  }

  UNSAFE_componentWillReceiveProps = ({ value }) => {
    if (value !== this.props.value) {
      this.setState({ value });
    }
  }

  handleEditClick = () => {
    this.setState(
      {
        editing: true
      },
      () => { this.input.focus(); }
    );
  }

  handleClickOutside = () => {
    if (this.state.editing) { this.handleSubmit(); }
  }

  render() {
    const { className, placeholder, onKeyPress, onDirty, onChange, onFocus, onBlur, linkTo } = this.props;
    return (
      <form className={cn(styles.Container, className)} onSubmit={this.handleSubmit}>
        <input
          value={this.state.value}
          ref={this.getInputRef}
          className={styles.Input}
          onChange={this.handleChange}
          placeholder={placeholder}
          readOnly={!this.state.editing}
          style={{
            display: this.state.editing ? 'block' : 'none',
            width: `${this.state.value.length}em`
          }}
        />
        {!this.state.editing ?
          linkTo ?
            <Link to={linkTo} className={styles.FakeInput}>
              {this.state.value}
            </Link>
            :
            <span className={styles.FakeInput}>
              {this.state.value}
            </span>
          : null
        }
        {
          !this.state.editing &&
          <div onClick={this.handleEditClick}>
            {this.props.children}
          </div>
        }
      </form>
    );
  }
}

export default onClickOutside(Input);



// WEBPACK FOOTER //
// ./src/components/common/SingleInputForm/Input.js